import { render, staticRenderFns } from "./ThreadForm.vue?vue&type=template&id=519cb412&scoped=true"
import script from "./ThreadForm.vue?vue&type=script&lang=js"
export * from "./ThreadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519cb412",
  null
  
)

export default component.exports